module.exports = __webpack_public_path__ + "static/media/featuredLogo-2.00cb8761.png";